import styled, { css } from 'styled-components/macro';
import { NavLink } from 'react-router-dom';
import { UserWrap } from 'components/organisms/UserActions/UserActions.styles';

export const SidebarContainer = styled.div`
  @media (max-width: 991px) {
    width: 68px !important;
  }
`;
export const Nav = styled.nav`
  position: relative;
`;

export const Ul = styled.ul`
  list-style: none;
  font-size: var(--font-size-sm);
  line-height: 20px;
  font-weight: 700;
  text-transform: capitalize;

  li {
    &:first-child {
      border-top-right-radius: 28px;
      border-top-left-radius: 28px;
      background: var(--bg-primary);
    }
    &:last-child {
      border-bottom-right-radius: 28px;
      border-bottom-left-radius: 28px;
      padding-bottom: 15px;
    }
    &.item-active {
      border-radius: 0 28px 28px 0;
    }
    &.prev-item-active {
      border-bottom-right-radius: 28px;
    }
    &.next-item-active {
      border-top-right-radius: 28px;
    }
  }
`;

export const StyledLink = styled(NavLink)`
  display: flex;
  align-items: center;
  color: var(--white);
  position: relative;
  transition: none;
  padding: 12px;
  border-radius: 50px;
  border-width: 4px;
  border-style: solid;
  border-color: transparent;
  /* transition: linear 0.3s; */
  z-index: 3;

  .light & {
    color: var(--gray-4);
  }

  &.active {
    color: var(--white);
    border-color: var(--primary);
    background: var(--primary-gradient);
  }
  &:hover {
    color: var(--light-blue);
  }

  .nav-active & {
    padding: 12px 20px;
  }

  i.icon {
    display: inline-block;
    font-size: 18px;
    line-height: 1;
    margin: 0 7px 0 0;
    transition: linear 0.3s;
  }
`;

export const Li = styled.li`
  padding: 0 12px;
  background: var(--grey-3);

  &.prev-item-active {
    border-bottom-right-radius: 18px;
  }

  &.item-active {
    padding-right: 0;
    padding-left: 12px;

    @media (min-width: 768px) {
      padding-left: 15px;
    }
  }

  .nav-active & {
    padding: 0 20px;

    &.item-active {
      padding-right: 0;
      padding-left: 20px;

      @media (min-width: 768px) {
        padding-left: 32px;
      }
    }

    &.title {
      a {
        visibility: visible;
        opacity: 1;
      }
    }
  }

  &.title {
    padding: 75px 15px 30px;
    a {
      display: block;
      padding: 0;
      visibility: hidden;
      opacity: 0;
      background: none;
      border: 0;
      color: var(--white);

      .light & {
        color: var(--light-blue);
      }
    }
    .icon {
      display: none;
    }
    span {
      display: block;
      opacity: 1;
      visibility: visible;
      padding: 0;
    }
  }
`;

export const Title = styled.span`
  position: relative;
  width: 0;
  visibility: hidden;
  opacity: 0;
  white-space: nowrap;
  transition: linear 0.3s;
`;

export const StyledSubMenu = styled.ul`
  font-size: 14px;
  /* background: var(--bg-dark); */
  border-radius: 0 0 16px 16px;
  position: relative;
  z-index: 1;
  ${({ hide }) =>
    hide &&
    css`
      opacity: 0;
      visibility: hidden;
      height: 0;
    `}

  ${({ filterMenu }) =>
    filterMenu &&
    css`
      font-size: 12px;
      line-height: 15px;
      font-weight: 500;
      padding: 8px 10px 16px 30px;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        top: -20px;
        bottom: 5px;
        left: 5px;
        right: 4px;
        border-radius: 13px;
        background: #23204d;
        z-index: -1;

        .light & {
          background: #fff;
        }
      }
    `}

  &:before {
    content: '';
    position: absolute;
    top: -23px;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 0 0 16px 16px;
    background: #1a193f;
    z-index: -1;
  }

  .light & {
    &:before {
      background: #fff;
    }
  }

  .icon {
    display: inline-block;
    font-size: 25px;
    line-height: 1;
    margin: 0;
    transition: linear 0.3s;
    margin-right: 10px;
  }
`;

export const ArrowHolder = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 12px;
  font-size: 20px;
`;

export const NavHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding: 20px 15px;
  background: var(--gray-3);
`;

export const NavTitle = styled.strong`
  display: none;
  font-size: 12px;
  line-height: 15px;

  .light & {
    color: #6f6c99;
  }
`;

export const CloseButton = styled.button`
  display: inline-block;
  font-size: 20px;
  line-height: 1;
  margin: 0 auto;
  color: var(--white);
  font-size: 20px;
  line-height: 1;

  .light & {
    color: var(--primary);
  }
`;

export const SideNavbar = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  position: sticky;
  top: 0.75rem;
  left: 0;
  width: 70px;
  padding-right: 3px;
  transition: linear 0.3s;
  z-index: var(--z-40);
  flex-shrink: 0;
  border: 1px solid rgba(205, 205, 205, 0.2);
  border-radius: 20px;
  height: calc(100vh - 150px);
  background: var(--gray-3);
  //box-shadow: rgba(100, 100, 111, 0.2) 0px 10px 20px 0px;

  @media (min-width: 992px) {
    width: 73px;
  }

  &::-webkit-scrollbar {
    width: 5px;
  }

  ${({ $loading }) =>
    !$loading &&
    css`
      &.nav-active {
        width: 240px;

        ${CloseButton} {
          margin: 0;
        }

        ${NavHead} {
          padding: 20px;
        }

        ${NavTitle} {
          display: block;
        }

        ${StyledLink} {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          position: relative;
        }

        ${Title} {
          opacity: 1;
          visibility: visible;
          width: auto;
          left: 0;
        }

        ${UserWrap} {
          position: relative;
        }
      }
    `}
`;

export const SubMenuItem = styled.li`
  background: none !important;
`;

export const SubMenuLink = styled(NavLink)`
  padding: 10px;
  color: var(--white);
  display: flex;
  align-items: center;

  .light & {
    color: var(--gray-4);
  }

  &.active {
    color: var(--light-blue);
  }
`;

export const SubMenuTitle = styled.span``;

export const SubMenuFilterItem = styled.li`
  background: #19173d !important;
  border-radius: 8px !important;
  padding: 0 !important;
  margin: 0 0 5px !important;

  .light & {
    background: none !important;
  }
`;

export const RadioLabel = styled.label`
  display: block;
  position: relative;
  padding: 10px 3px 10px 10px;
  cursor: pointer;

  .light & {
    padding: 8px 3px;
  }

  input[type='checkbox'] {
    display: none;
  }

  input[type='checkbox'] {
    &:checked ~ {
      ${ArrowHolder} {
        transform: translateY(-50%) scaleY(-1);
      }

      .fake-radio {
        &:before {
          opacity: 1;
        }
      }
    }
  }

  .fake-radio {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -16px;
    width: 10px;
    height: 10px;
    border: 1px solid var(--white);
    border-radius: 25px;

    &:before {
      opacity: 0;
      content: '';
      position: absolute;
      top: 2px;
      left: 2px;
      width: 4px;
      height: 4px;
      border-radius: 25px;
      background: var(--white);
    }

    .light & {
      border: 1px solid var(--light);

      &:before {
        background: var(--light);
      }
    }
  }
`;

export const CategorySubFilterMenu = styled.ul`
  position: relative;
  font-size: 11px;
  line-height: 13px;
  font-weight: 500;
  padding: 0 0 0 40px;
  margin: 0 10px 0 0;
  overflow: auto;
  max-height: 130px;

  .light & {
    padding: 0 0 0 25px;
  }

  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-track {
    background: #23204d;
  }
`;

export const CategorySubFilterItem = styled.li`
  padding: 8px 0;
  border-radius: 0 !important;
  background: none !important;
`;

export const CheckboxLabel = styled.label`
  display: block;
  position: relative;
  cursor: pointer;

  input[type='checkbox'] {
    display: none;
  }

  input[type='checkbox'] {
    &:checked ~ {
      .fake-checkbox {
        border-color: #29c6f2;
        background: #29c6f2;
        &:before {
          opacity: 1;
        }
      }
    }
  }

  .fake-checkbox {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -20px;
    width: 12px;
    height: 12px;
    border-radius: 2px;
    border: 1px solid var(--white);

    .light & {
      border: 1px solid var(--light);
    }

    &:before {
      opacity: 0;
      content: '\\e904';
      font-family: 'icomoon';
      font-size: 9px;
      line-height: 1;
      color: var(--black);
      position: absolute;
      top: 1px;
      left: 1px;
    }
  }
`;
